import { render, staticRenderFns } from "./UrunRezervasyonBilgiArac.vue?vue&type=template&id=e623a948&scoped=true"
import script from "./UrunRezervasyonBilgiArac.vue?vue&type=script&lang=js"
export * from "./UrunRezervasyonBilgiArac.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e623a948",
  null
  
)

export default component.exports